import React from 'react';
import { development } from '../data/landing';
export function DevelopmentSection() {
  return <section className="w-full bg-white py-20 md:py-28" aria-labelledby="development-title" data-id="element-48" data-mp="1z9pjw002p5z9">
      <div className="mx-auto max-w-6xl px-5 text-center" data-id="element-49" data-mp="1uizbsf09ip0v">
        <h2 id="development-title" className="font-display text-3xl font-bold text-ink md:text-5xl" data-id="element-50" data-mp="1uhei0rlrva42">
          Built for whole-child development
        </h2>
        <ul className="mt-12 grid gap-x-10 gap-y-10 sm:grid-cols-2 lg:grid-cols-3" data-id="element-51" data-mp="1kme5zrgf59vz">
          {development.map(({
          icon: Icon,
          title,
          text
        }) => <li key={title} className="flex flex-col items-center" data-id="element-52" data-mp="1fol2x7aewvzx">
              <span className="flex h-12 w-12 items-center justify-center rounded-full bg-mint" data-id="element-53" data-mp="1bl6kk9z043jb">
                <Icon className="h-6 w-6 text-teal" aria-hidden data-id="element-54" data-mp="16n4qyv3y8ltl" />
              </span>
              <h3 className="mt-4 font-display text-xl font-bold text-ink" data-id="element-55" data-mp="35xmkyu548ng9">{title}</h3>
              <p className="mt-1 max-w-xs text-base text-inkSoft" data-id="element-56" data-mp="30zbf0uhxyx3b">{text}</p>
            </li>)}
        </ul>

        <p className="mt-20 font-display text-2xl font-bold leading-tight md:text-4xl" data-id="element-57" data-mp="3stolptzv7793">
          <span className="text-berry" data-id="element-58" data-mp="1p7y6r3sqwbt">Creativity</span> <span className="text-inkSoft" data-id="element-59" data-mp="1lsipn67nl9v">+</span>{' '}
          <span className="text-teal" data-id="element-60" data-mp="3jutd6b9cll2m">Learning</span> <span className="text-inkSoft" data-id="element-61" data-mp="3jw4hcc6pguu9">+</span>{' '}
          <span className="text-tang" data-id="element-62" data-mp="3otw64xc200u8">Fun</span> <span className="text-inkSoft" data-id="element-63" data-mp="3ouyzdbwumfdb">=</span>{' '}
          <span className="text-ink" data-id="element-64" data-mp="gct4etvyxbny">Essential skills for life</span>
        </p>
      </div>
    </section>;
}